import { createChildListViewContainer } from 'factories/ChildListView'
import actions from 'actions/rfqs/rfqItems'
import Component from 'components/Rfqs/Items/FormView/Pricing'

export default createChildListViewContainer({
  actions,
  extraStateToProps: (state, props) => ({
    settingsType: props.settingsType ?? 'rfqItemSupplierDetail',
  }),
})(Component)
